import { toast } from "react-toastify";

import index from "./index";
import agruparArray from "../../historial/agruparArray";
import obtenerHistorialPorConcesion from "../historial/obtenerPorConcesion";
import expediente from "../../xml/obtenerExpedientePorAutorizacion";

export default async function escoger(idConcesion, data, setData, setChecked) {
    const id = toast.loading("Cargando...");
    const { concesiones } = data;
    const dataWS = await expediente(idConcesion);

    concesiones[index(idConcesion, concesiones)].numeroExpediente = await dataWS?.NoExpedienteActual ?? "";
    const dataHistorial = await obtenerHistorialPorConcesion(idConcesion);
    setData({
        ...data, concesionActual: {
            ...concesiones[index(idConcesion, concesiones)],
        },
        historial: [...dataHistorial],
        historialArray: [...agruparArray(dataHistorial, 10)]
    });
    setChecked(true);
    toast.update(id, { render: "Hecho!", type: "success", isLoading: false, autoClose: 500, draggable: true });
}